<template>
  <div
    class="coupon_loading"
    :class="{ is_inline: isInline }"
    role="status"
    aria-live="polite"
  >
    <span class="coupon_loading_spinner" aria-hidden="true"></span>
    {{ text }}
  </div>
</template>

<script>
// 優惠券各處共用的圓圈載入動畫；isInline 用於卡片內與文字橫排的小尺寸
export default {
  name: "CouponLoading",
  props: {
    text: { type: String, default: "載入中…" },
    isInline: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
.coupon_loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0;
  color: #666;
  font-size: 14px;
}

.coupon_loading_spinner {
  width: 36px;
  height: 36px;
  margin-bottom: 12px;
  border: 4px solid #e5e5e5;
  border-top-color: #fd5001;
  border-radius: 50%;
  animation: coupon_loading_spin 0.8s linear infinite;
}

.coupon_loading.is_inline {
  display: inline-flex;
  flex-direction: row;
  gap: 6px;
  padding: 0;
  color: inherit;
  font-size: inherit;
  font-weight: inherit;

  .coupon_loading_spinner {
    width: 14px;
    height: 14px;
    margin: 0;
    border-width: 2px;
  }
}

@keyframes coupon_loading_spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
